/* Preference storage requires both explicit opt-in and Shopify preference consent. */
(() => {
  'use strict';
  if (window.MoonmeetChartStorage) return;
  const key = 'moonmeet.chart.v1';
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed() === true; }
    catch { return false; }
  };
  function clear() { try { localStorage.removeItem(key); return true; } catch { return false; } }
  function read() {
    if (!allowed()) { clear(); return null; }
    try {
      const raw = localStorage.getItem(key);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data.version !== 1 || !/^\d{4}-\d{2}-\d{2}$/.test(data.date) || typeof data.time !== 'string' || !/^([01]\d|2[0-3]):[0-5]\d$|^$/.test(data.time) || typeof data.full !== 'boolean' || typeof data.unknown !== 'boolean' || !(data.cityId === null || Number.isInteger(data.cityId))) throw Error('storage');
      return data;
    } catch { clear(); return null; }
  }
  function write(data) {
    if (!allowed()) return false;
    try { localStorage.setItem(key,JSON.stringify({version:1,...data})); return true; }
    catch { return false; }
  }
  window.MoonmeetChartStorage = Object.freeze({allowed,read,write,clear});
  // Preference withdrawal can happen on Home, Shop or Cart, after leaving Chart.
  // This listener removes only our key; it never reads inputs or sends events/data.
  document.addEventListener('visitorConsentCollected', () => { if (!allowed()) clear(); });
  if (window.Shopify?.customerPrivacy && !allowed()) clear();
})();
